<template lang="pug">
  .CreditAlert
    v-alert.py-2.mt-2.round-xl(:color="creditBalance > 0 ? 'neutral700' : 'danger500'"  prominent style="width:100%")  
      div.d-flex.align-center
        v-icon.mr-5(color="neutral100" size="24") $yzi-wallet-solid-02
        div
          div.text-xxs.neutral100--text Credit Balance
          div.text-sm.font-medium.neutral100--text {{ creditBalance | displayPrice($currency) }}
        v-spacer
        y-button(label="Reload" outlined color="neutral100" size="sm"  @click="openReload")
      v-divider.neutral100.mt-3.mb-2
      v-row(dense)
        v-col
          div.text-xxs.neutral100--text SMS rate
          div.text-xs.neutral100--text RM 0.15/
            span.text-xxs SMS
        v-col
          div.text-xxs.neutral100--text WhatsApp rate
          div.text-xs.neutral100--text RM 0.05/
            span.text-xxs WhatsApp
        v-col
          div.text-xxs.neutral100--text Email rate
          div.text-xs.neutral100--text RM 0.05/
            span.text-xxs Email
    .modals
      credit-reload(v-if="showCreditReloadDialog" :open.sync="showCreditReloadDialog" :refreshPage="!showTitle")
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import CreditReload from '@/components/yezzabook/dialogs/CreditReload.vue'

export default {
  name: 'CreditAlert',
  components:{CreditReload},
  props: ['credit', 'title', 'showTitle', 'titleFont', 'descFont', 'buttonSize'],
  data: () => ({
    showCreditReloadDialog: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
  },
  mounted () {
    this.fetchCompany()
    this.$wamp.subscribe(`company:${this.company.id}:prepaid_credits`, (args, kwArgs) => {
      const company = { ...this.company}
      company.prepaid_credits = kwArgs.prepaid_credits
      this.updateCompany(company)
    })
  },
  methods:{
    ...mapActions([
      'updateCompany'
    ]),
    openReload() {
      this.showCreditReloadDialog = true
    },
    fetchCompany () {
      this.$axios.get(`/companies/${this.company.id}`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
    },
  }
}
</script>

<i18n>
{
  "en": {
    "credit_balance": "Credit balance",
    "reload_now_to": "Reload now to",
    "send_out_reminders": "send out reminders"
  },
  "id": {
    "credit_balance": "Saldo kredit",
    "reload_now_to": "Muat lagi sekarang untuk",
    "send_out_reminders": "dapat mengirim pengingat"
  }
}
</i18n>